import React, {RefObject} from 'react';
import Disc from "./Disc";
import ReactPlayer from "react-player";
import {Howl} from 'howler'
import LabelImage from '../../assets/img/label.png';
import TurnTable from '../../assets/img/turn-table.png';
import { ImageButton } from './ImageButton';
import cyper from '../../assets/img/cypher.png';
import cyperPush from '../../assets/img/cypher-push.png';
import playButton from '../../assets/img/play.png';
import playPushButton from '../../assets/img/play-push.png';
import stopButton from '../../assets/img/stop.png';
import stopPushButton from '../../assets/img/stop-push.png';
import { lookup } from 'dns';

interface Props {
    title: string;
    music: any;
    play: boolean;
    toggle: () => void;

    cyper: any;
    playCypher: boolean;
    toggleCyper: () => void;
}

interface State {}

export default class MusicPlayer extends React.Component<Props, State> {
    // private playerRef: RefObject<ReactPlayer>;
    // private playerCyperRef: RefObject<ReactPlayer>;
    sound: Howl;
    soundCyper: Howl;

    constructor(props: Props) {
        super(props);
        // this.playerRef = React.createRef();
        this.sound = new Howl({
            src: [props.music],
            loop: true,
        });
        this.soundCyper = new Howl({
            src: [props.cyper],
            loop: true,
        })
    }

    handleStop() {
        if (this.props.play) {
            this.props.toggle()
        }
        if (this.props.playCypher) {
            this.props.toggleCyper()
        }
    }

    handleDisc() {
        if (this.props.play || this.props.playCypher) {
            this.handleStop()
        } else {
            this.props.toggle()
        }
    }

    componentDidUpdate() {
        if (this.props.play) {
            this.sound.play()
        } else {
            this.sound.stop()
       }
        if (this.props.playCypher) {
            this.soundCyper.play()
        } else {
            this.soundCyper.stop()
        }
    }

    render(): React.ReactNode {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ position: 'relative' }}>
                    <img src={LabelImage} style={{ position: 'absolute', top: 0, left: 0, right: 0, margin: '0 auto', zIndex: -1 }}/>
                    <h1>{this.props.title}</h1>
                </div>
                {/* <ReactPlayer url={this.props.music} playing={this.props.play} loop={true} height={0} width={0} ref={this.playerRef} onStop={this.onStop()}/> */}
                <div style={{ position: 'relative' }}>
                    <img src={TurnTable} style={{ width: '100%' }}/>
                    <Disc 
                        onClick={this.handleDisc.bind(this)} 
                        size={300} 
                        halfSize={150} 
                        spinning={this.props.play || this.props.playCypher}
                        style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto' }}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ImageButton style={{ width: 94, height: 78, background: 'rgba(0,0,0,0)', color: 'rgba(0,0,0,0)', borderColor:'rgba(0,0,0,0)', appearance: 'none' }} src={stopButton} srcPressed={stopPushButton} onClick={this.handleStop.bind(this)} />
                    <ImageButton style={{ width: 94, height: 78, background: 'rgba(0,0,0,0)', color: 'rgba(0,0,0,0)', borderColor:'rgba(0,0,0,0)' }} src={playButton} srcPressed={playPushButton} onClick={this.props.toggle} enable={!this.props.play} pressed={this.props.play}/>
                    <ImageButton style={{ width: 118, height: 77, background: 'rgba(0,0,0,0)', color: 'rgba(0,0,0,0)', borderColor:'rgba(0,0,0,0)' }} src={cyper} srcPressed={cyperPush} onClick={this.props.toggleCyper} pressed={this.props.playCypher}  />
                </div>
            </div>
        );
    }

    // private onStop() {
    //     if (this.playerRef.current) {
    //         this.playerRef.current.seekTo(0, 'fraction')
    //     }
    // }
}

